import { render, staticRenderFns } from "./IconNoContract.vue?vue&type=template&id=68666d8e"
import script from "./IconNoContract.vue?vue&type=script&lang=js"
export * from "./IconNoContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports